import { useAppSelector } from '@frontend/common';
import { ColliTypeConstraintData, isColliTypeConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ColliTypeConstraintDataInputProps } from './colli-type-constraint-data-input.component';

interface ViewProps {
    formValues: ColliTypeConstraintData;
}

const useColliTypeConstraintDataInput = (props: ColliTypeConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isColliTypeConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { colli_type: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useColliTypeConstraintDataInput;
